import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import Breadcrumb from 'components/Admin/Breadcrumb';
import { Navigate, Link } from 'react-router-dom';
import Alert from 'components/Alert';
import { confirmAlert } from 'react-confirm-alert';
import NoImage from 'assets/images/avatar.png';
import { toast } from 'react-toastify';

import { listServiceApi } from './ListService.service.js';

const ListService = () => {
	const [services, setServices] = useState([]);
	const [servicesMeta, setServicesMeta] = useState({});
	const [page, setPage] = useState(1);
	const [redirect, setRedirect] = useState(0);
	const [alertType, SetAlertType] = useState('');
	const [alertMessage, SetAlertMessage] = useState('');

	useEffect(() => {
		getServiceList();
	}, [page]);

	const getServiceList = async () => {
		const list = await listServiceApi(page);
		if (list.data.status === 200) {
			setServices(list.data.data.records);
			setServicesMeta(list.data.data.meta);
		} else {
			toast.error(list.data.error);
		}
	};
	const columns = [
		{
			name: 'Icon',
			cell: (row) => (
				<span className="img-block">
					<img alt={row?.logo} src={`${process.env.REACT_APP_RESOURCE_URL}/${row?.logo}`} height={100} />
				</span>
			),
		},
		{
			name: 'Name',
			selector: (row) => row?.serviceName,
			sortable: true,
		},
		{
			name: 'Short Description',
			selector: (row) => row?.ShortDesc,
			sortable: true,
		},

		{
			name: 'Status',
			cell: (row) => (row.status === 0 ? <span className="badge bg-danger">Inactive</span> : <span className="badge bg-success">Active</span>),
		},
		{
			name: 'Action',
			cell: (row) => (
				<div className="dropdown">
					<div className="actionList " id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
						<svg
							style={{ cursor: 'pointer' }}
							xmlns="http://www.w3.org/2000/svg"
							width={24}
							height={24}
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							strokeWidth={2}
							strokeLinecap="round"
							strokeLinejoin="round"
							className="feather feather-sliders dropdown-toggle"
							data-toggle="dropdown"
							role="button"
							aria-expanded="false"
						>
							<line x1={4} y1={21} x2={4} y2={14} />
							<line x1={4} y1={10} x2={4} y2={3} />
							<line x1={12} y1={21} x2={12} y2={12} />
							<line x1={12} y1={8} x2={12} y2={3} />
							<line x1={20} y1={21} x2={20} y2={16} />
							<line x1={20} y1={12} x2={20} y2={3} />
							<line x1={1} y1={14} x2={7} y2={14} />
							<line x1={9} y1={8} x2={15} y2={8} />
							<line x1={17} y1={16} x2={23} y2={16} />
						</svg>
					</div>
					<div className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
						<Link to={`/admin/cms/edit-service/${row?.id}`} className="dropdown-item">
							Edit
						</Link>
					</div>
				</div>
			),
		},
	];

	return (
		<>
			<Breadcrumb
				data={[
					{ link: '#', name: 'Service' },
					{ link: '#', name: 'List' },
				]}
				title="Service List"
			/>
			{alertType && <Alert type={alertType} message={alertMessage} />}
			<div className="row mb-3 justify-content-between">
				<div className="col-lg-6">
					<div className="cmn-a-tag-wrap">
						<Link to={'/admin/cms/add-service'} className="cmn-a-tag">
							Add Service
						</Link>
					</div>
				</div>
			</div>
			<div className="datatable-wrap">
				<DataTable
					// title="Employees"
					columns={columns}
					data={services}
					striped
					// highlightOnHover
					// selectableRows
					pagination
					paginationServer
					paginationTotalRows={servicesMeta.totalRecords}
					paginationPerPage={15}
					paginationComponentOptions={{
						noRowsPerPage: true,
					}}
					onChangePage={(page) => setPage(page)}
				/>
			</div>
		</>
	);
};

export default ListService;
